import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { catchError, Observable, tap } from "rxjs";
import { AuthService } from "src/app/common/providers/auth.service";
import { ConfigService } from "src/app/config.service";
import { CommonService } from "src/app/services/ common.service.";
import { environment } from "../../../environments/environment";
import { SearchRequest } from "src/app/mail/shared/models";
import { CommonUtils } from "src/app/common/utils/common-util";


@Injectable({ providedIn: "root" })

export class TaskService {
 isCordovaOrElectron = environment.isCordova || environment.isElectron;

constructor(
    private http: HttpClient,
    private configService: ConfigService,
    private authService: AuthService,
    private commonService: CommonService,
) {}
private getZimbraHeader(): HttpHeaders {
  let headers = new HttpHeaders({
    "Content-Type": "application/json",
    "Accept": "application/json"
  });

  if (this.isCordovaOrElectron) {
    headers = headers.set("Authorization", this.authService.getAuthToken());
  }

  return headers;
}

getUserTaskFolders(body: { view: string }): Observable<any> {
return this.http
    .post(
    `${this.configService.API_URL}/api/getFolderList`,
    body,
    { headers: this.getZimbraHeader() }
    )
    .pipe(catchError(this.authService.handleErrorObservable.bind(this)));
}

  searchRequest(body: SearchRequest): Observable<any> {
    const t1 = new Date().getTime();
    return this.http.post(this.configService.API_URL + "/api/searchRequest", body, { headers: this.getZimbraHeader() }).pipe(tap(res => {
      const t2 = new Date().getTime();
      const performance = (t2 - t1) / 1000;
      console.log(`[API][searchRequest] took ${performance} s for API call`, body, res);
      if (!!this.configService.get("logSentryPerf")) {
        CommonUtils.sentryLog(`[API][searchRequest] took ${performance} s - ${JSON.stringify(body)}`, performance);
      }
    }));
  }

}
